import PageWrapper from './PageWrapper';

export const wrapPageElement = PageWrapper;
